import finameImage from "AdvisoryManagement/Assets/Images/FinAM.png";

export const FinamPage = () => {
	return (
		<img
			src={finameImage}
			alt="finAM"
			style={{ maxWidth: "100%", height: "auto" }}
		/>
	);
};
